<div class="model-detail-home flex flex-col min-h-screen bg-[var(--consumer-canvas-bg)]">
  <app-header [forceLightBackground]="true"></app-header>

  <main class="model-detail-home__main flex-1 w-full pt-20">
    <div class="model-detail-home__container mx-auto w-full px-4 pb-10">
      @if (loading()) {
        <div class="model-detail-home__skeleton flex flex-col gap-6 py-4">
          <app-skeleton variant="detail-header" />
          <app-skeleton variant="detail-body" />
        </div>
      } @else {
        <app-detail-header
          [config]="headerConfig"
          [showAssetActions]="true"
          [isLoggedIn]="isLoggedIn()"
          [isBookmarked]="isBookmarked()"
          [isLiked]="isLiked()"
          (bookmarkClick)="onHeaderBookmarkClick()"
          (likeClick)="onHeaderLikeClick()"
          (loginRequired)="showLoginModal.set(true)"
        ></app-detail-header>

        <div class="mt-6">
          @if (modelId) {
            <app-model-detail-model-tab
              [detailRows]="detailRows()"
              [modelDescription]="modelDescription"
              [modelTags]="modelTags"
              [activityMetrics]="activityMetrics"
              [mediaUrl]="mediaUrl"
            />
          }
        </div>
      }
    </div>
  </main>

  <app-footer></app-footer>

  @if (showLoginModal()) {
    <app-login-modal (visibleChange)="onLoginModalClose()"></app-login-modal>
  }
</div>
